// extracted by mini-css-extract-plugin
export default {"placeholder":"AEEgJ","spinner":"Bdbsi","label":"U_YAF"};